import { render, staticRenderFns } from "./word2vec-detail.vue?vue&type=template&id=6616cdcd&scoped=true&"
import script from "./word2vec-detail.vue?vue&type=script&lang=js&"
export * from "./word2vec-detail.vue?vue&type=script&lang=js&"
import style0 from "./word2vec-detail.vue?vue&type=style&index=0&id=6616cdcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616cdcd",
  null
  
)

export default component.exports